// extracted by mini-css-extract-plugin
export default {"container":"HideLockedToggle__container___fSJEM","switchContainer":"HideLockedToggle__switchContainer___o0B2E","separator":"HideLockedToggle__separator___aIVhK"};